import _ from 'lodash';
import { FixMeLater } from '../temporary-types';

class LodashUtilsMain {
  get = (object: FixMeLater, path: FixMeLater, defaultValue?: FixMeLater) =>
    _.get(object, path, defaultValue);

  every = (object: FixMeLater, val: FixMeLater) => _.every(object, val);

  flatMap = (data: FixMeLater, key: FixMeLater) => _.flatMap(data, key);

  find = (collection: FixMeLater, predicate: FixMeLater, fromIndex = 0) =>
    _.find(collection, predicate, fromIndex);

  isEmpty = (object: FixMeLater) => _.isEmpty(object);

  map = (object: FixMeLater, val: FixMeLater) => _.map(object, val);

  isAnyValueEmptyInArray = (myArr: FixMeLater) => _.some(myArr, (value) => _.isEmpty(value.trim()));

  omit = (obj, keys: string[] ):any =>  _.omit(obj, keys); 

}

const LodashUtils = new LodashUtilsMain();

export default LodashUtils;
